import * as React from 'react';
import { toLower } from 'lodash';
import { useTranslation } from '@lib/useTypedTranslation';
import { useState } from 'react';
import moment from 'moment';

import ThresholdSettings from '../thresholdSettings';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  submitInProgress: boolean,
  timeStamp: number,
  onDataChanged: (data: WorldSettings) => void
}

const ns = 'settings' as const;

export function UsageSettings(props: IProps) {
  const { t } = useTranslation(ns);
  const [alertTimeStamp, setAlertTimeStamp] = useState<number>(props.timeStamp);

  if (props.timeStamp > alertTimeStamp) {
    setAlertTimeStamp(props.timeStamp);
  }

  function onDataChanged(data: number, field: 'warning' | 'problem') {
    if (field === 'warning') {
      props.onDataChanged({ ...props.worldSettings, deviceUtilisationIdleYellow: data });
    } else {
      props.onDataChanged({ ...props.worldSettings, deviceUtilisationIdleRed: data });
    }
  }

  function onAlertToggled(data: boolean, initialSettings: { warning: number, problem: number }) {
    setAlertTimeStamp(moment.utc().valueOf());
    props.onDataChanged({
      ...props.worldSettings,
      deviceUtilisationIdleEnabled: data,
      deviceUtilisationIdleYellow: initialSettings.warning,
      deviceUtilisationIdleRed: initialSettings.problem
    });
  }

  return (
    <ThresholdSettings
      key={alertTimeStamp}
      title={t('USAGE_TITLE', { ns })}
      message={t('USAGE_MESSAGE', { ns })}
      popoverText={t('USAGE_POPOVER', { ns })}
      unit={{ key: 'USAGE_UNIT' }}
      maxValue={30}
      className="usage"
      warning={props.worldSettings.deviceUtilisationIdleYellow}
      problem={props.worldSettings.deviceUtilisationIdleRed}
      dataUpdated={onDataChanged}
      disabled={props.submitInProgress}
      alertEnabled={props.worldSettings.deviceUtilisationIdleEnabled}
      alertToggled={onAlertToggled}
    />
  );
}
